import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2, ChevronDown } from 'lucide-react';
import { MetaTags } from '../../../../components/SEO/MetaTags';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
export function BlogPostEmotionalDrainKO() {
  const articleData = {
    title: '왜 어떤 사람들은 우리를 지치게 합니까? (AI가 설명합니다)',
    description: '텍스트로 인해 감정적으로 지치셨나요? Toxic Detector의 AI가 관계에서 일방적인 의사 소통과 미묘한 감정적 소모 패턴을 감지하는 방법을 알아보세요.',
    slug: 'emotional-drain-relationships-ai',
    publishDate: '2025-09-03',
    author: 'Toxic Detector 편집팀'
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: '관계에서의 감정적 소모란 무엇입니까?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '감정적 소모는 누군가와의 상호 작용으로 인해 지속적으로 피곤하거나 좌절하거나 죄책감을 느낄 때 발생하며, 종종 일방적이거나 조작적인 의사 소통으로 인해 발생합니다.'
      }
    }, {
      '@type': 'Question',
      name: '문자 메시지가 어떻게 감정적 소모를 유발할 수 있습니까?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '반복되는 일방적인 메시지, 죄책감 유발, 일관성 없는 참여 또는 미묘한 비판은 큰 갈등 없이도 당신을 지치게 할 수 있습니다.'
      }
    }, {
      '@type': 'Question',
      name: 'AI가 누가 내 감정적 에너지를 고갈시키는지 감지할 수 있습니까?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '네. Toxic Detector는 텍스트 패턴, 어조 및 참여를 분석하여 일방적, 조작적 또는 소모적인 행동을 즉시 강조합니다.'
      }
    }]
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.title,
    description: articleData.description,
    image: 'https://toxicdetector.com/images/logo.png',
    author: {
      '@type': 'Person',
      name: articleData.author
    },
    datePublished: articleData.publishDate,
    url: `https://toxicdetector.com/ko/blog/${articleData.slug}`
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: 'https://toxicdetector.com/'
      });
    } catch (err) {
      navigator.clipboard.writeText('https://toxicdetector.com/');
      alert('링크가 클립보드에 복사되었습니다!');
    }
  };
  return <>
      <MetaTags title="왜 어떤 사람들은 우리를 지치게 합니까? — AI가 설명하는 감정적 소모 | ToxicDetector" description="텍스트로 인해 감정적으로 지치셨나요? Toxic Detector의 AI가 일방적인 의사 소통과 미묘한 감정적 소모 패턴을 감지하는 방법을 알아보세요." keywords="관계에서의 감정적 소모, 일방적인 텍스트 패턴, 에너지 뱀파이어, AI 감정 분석" canonical={`https://toxicdetector.com/ko/blog/${articleData.slug}`} ogType="article" ogImage="https://cdn.magicpatterns.com/uploads/dA7JvMmr79gFQy3nZ9PyWw/file_00000000ee5472468a16f1060b3742e2.png" schema={[faqSchema, articleSchema]} data-id="element-7998" data-mp="2hiko1s3igsxt" />

      <div className="flex flex-col w-full min-h-screen bg-white" data-id="element-7999" data-mp="3a6ox8nlajo59">
        <header className="bg-white/95 backdrop-blur-md border-b border-gray-100 sticky top-0 z-50" data-id="element-8000" data-mp="3a6gj6sdfmcsh">
          <div className="max-w-4xl mx-auto px-6 py-5" data-id="element-8001" data-mp="3f3yjjuddvjov">
            <div className="flex items-center justify-between" data-id="element-8002" data-mp="13ipl1uodcd03">
              <Link to="/" className="flex items-center gap-2 group" data-id="element-8003" data-mp="13kajvwhpui3r">
                <span className="text-2xl" data-id="element-8004" data-mp="yk4w4rekhfqy">🚩</span>
                <span className="text-xl font-bold text-gray-900 group-hover:text-red-600 transition-colors" data-id="element-8005" data-mp="ts4oecs99ijt">
                  ToxicDetector
                </span>
              </Link>
              <div className="flex items-center gap-3" data-id="element-8006" data-mp="krooteemuvk8">
                <Link to="/signup" className="hidden sm:inline-block bg-red-600 text-white px-5 py-2.5 rounded-lg font-semibold text-sm hover:bg-red-700 transition-all shadow-sm hover:shadow-md" data-id="element-8007" data-mp="ktj86oa9afm7">
                  무료 스캔
                </Link>
                <button onClick={handleShare} className="p-2.5 hover:bg-gray-100 rounded-lg transition-colors" aria-label="기사 공유" data-id="element-8008" data-mp="5w8s11mo4lk5">
                  <Share2 size={20} className="text-gray-600" data-id="element-8009" data-mp="2098ffgxaik1z" />
                </button>
              </div>
            </div>
          </div>
        </header>

        <article className="max-w-4xl mx-auto w-full px-6 py-16" data-id="element-8010" data-mp="2d910cyqk2w01">
          <Link to="/" className="inline-flex items-center text-gray-600 text-sm mb-12 hover:text-gray-900 transition-colors group" data-id="element-8011" data-mp="2d651972z21a0">
            <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-8012" data-mp="238qnxgcchslx" />
            홈으로 돌아가기
          </Link>

          <header className="mb-16" data-id="element-8013" data-mp="1uaopn8jzxe2c">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 tracking-tight leading-[1.1] text-gray-900" data-id="element-8014" data-mp="1ubq1vgcr06ln">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-500 text-sm gap-3" data-id="element-8015" data-mp="1kkvgee7btb19">
              <time dateTime={articleData.publishDate} data-id="element-8016" data-mp="16jiz9zgfj3ds">
                {new Date(articleData.publishDate).toLocaleDateString('ko-KR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-8017" data-mp="my90q1inwckj">•</span>
              <span data-id="element-8018" data-mp="mzkdurxzywob">{articleData.author}</span>
            </div>
          </header>

          <div className="mb-16" data-id="element-8019" data-mp="10z3bgqt6mpmd">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ajgMhQjEKnfJfWgPd5sqFq/1763122862210.jpg" alt="AI가 문자 메시지의 감정적 소모 패턴 분석" className="w-full rounded-2xl shadow-lg" data-id="element-8020" data-mp="10zbpwn4ye2zo" />
          </div>

          <div className="bg-gray-50 rounded-2xl p-8 border border-gray-200 mb-16" data-id="element-8021" data-mp="15xwqwos14qp6">
            <h2 className="font-bold text-xl mb-6 text-gray-900" data-id="element-8022" data-mp="1jo9vch5ppn9r">목차</h2>
            <ol className="space-y-3.5 text-base list-decimal list-inside" data-id="element-8023" data-mp="1jqcmj4ilpmg2">
              <li data-id="element-8024" data-mp="1fnq1pnkcl1sd">
                <a href="#always-something-wrong" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8025" data-mp="1fpajsdph6s9c">
                  "항상 뭔가 잘못된" 친구
                </a>
              </li>
              <li data-id="element-8026" data-mp="mb85uu478kqa">
                <a href="#only-when-they-need" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8027" data-mp="mbrnsatun94b">
                  필요할 때만 문자하는 사람
                </a>
              </li>
              <li data-id="element-8028" data-mp="101blh28kpg6r">
                <a href="#dry-texting" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8029" data-mp="101v3eiy844ks">
                  감정 없는 "단답형"
                </a>
              </li>
              <li data-id="element-8030" data-mp="19y7z1mdbwsi6">
                <a href="#ghost-return" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8031" data-mp="1a1lzuq6cgtni">
                  잠수 & 복귀 아티스트
                </a>
              </li>
              <li data-id="element-8032" data-mp="3ft9biu3xhvzh">
                <a href="#guilt-tripper" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8033" data-mp="3fu14rya1zhml">
                  미묘한 죄책감 유발자
                </a>
              </li>
              <li data-id="element-8034" data-mp="3dae4q3e98f12">
                <a href="#faux-supporter" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8035" data-mp="38huv1hiou41j">
                  가짜 지지자
                </a>
              </li>
              <li data-id="element-8036" data-mp="2ykgdfel1397n">
                <a href="#healthy-toxic-combo" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8037" data-mp="2ykzyh45z6dpw">
                  "건강-유독" 콤보
                </a>
              </li>
            </ol>
          </div>

          <div className="prose prose-lg max-w-none" data-id="element-8038" data-mp="3m7ybtsyst5jl">
            <p className="text-2xl mb-10 leading-relaxed text-gray-700 font-medium" data-id="element-8039" data-mp="3mau697bftc3a">
              누군가에게 문자를 보내고 대화가 싸움이 아니었음에도 불구하고
              나중에 피곤하거나 짜증나거나 이상하게 죄책감을 느낀 적이 있나요?
              그것은{' '}
              <strong className="text-gray-900" data-id="element-8040" data-mp="26s8z4kszw8wf">관계에서의 감정적 소모</strong>
              이며, 생각보다 흔합니다.
            </p>
            <p className="mb-16 text-lg leading-relaxed text-gray-600" data-id="element-8041" data-mp="9r3fj4cqvwyv">
              그것은 <strong className="text-gray-900" data-id="element-8042" data-mp="9txw2ksn0xn0">일방적인 문자</strong>{' '}
              패턴과 미묘한 조작입니다. 저희{' '}
              <strong className="text-gray-900" data-id="element-8043" data-mp="qwvezmjjyqq">AI 분석</strong>은 이러한 패턴을
              즉시 읽습니다.
            </p>

            <section id="always-something-wrong" className="mb-16" data-id="element-8044" data-mp="5pq66kag1bn7">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8045" data-mp="5s436yoooxxe">
                1️⃣ "항상 뭔가 잘못된" 친구
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-8046" data-mp="xhpabtxqnkqx">
                휴대폰을 확인하고 즉시 느낍니다:
              </p>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-8047" data-mp="jozn5m6h49s8">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-8048" data-mp="onu5yo4fxycc">
                  "오 맙소사... 이번엔 또 뭐야?"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8049" data-mp="1cclpkr3yt8di">
                모든 메시지는 스트레스, 혼란 또는 불만입니다. AI는 이것을{' '}
                <strong className="text-gray-900" data-id="element-8050" data-mp="1qjgn419dnj70">일방적인 감정적 부하</strong>
                로 표시합니다.
              </p>
            </section>

            <section id="only-when-they-need" className="mb-16" data-id="element-8051" data-mp="1mhllevnjb3sp">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8052" data-mp="20ab9d5mmiisg">
                2️⃣ 필요할 때만 문자하는 사람
              </h2>
              <div className="bg-gray-50 border border-gray-200 rounded-xl p-8 mb-8" data-id="element-8053" data-mp="1vb8fmhc3fyzs">
                <p className="mb-4 text-lg text-gray-700" data-id="element-8054" data-mp="17lvxgrysgglc">
                  <strong className="text-gray-900" data-id="element-8055" data-mp="13jsjnwonczww">절대:</strong> "잘 지내?"
                </p>
                <p className="text-lg text-gray-700" data-id="element-8056" data-mp="1hjafux49vfga">
                  <strong className="text-gray-900" data-id="element-8057" data-mp="1hkv98jeuosck">항상:</strong> "...해줄 수
                  있어?"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8058" data-mp="1cmjz07kn8ftt">
                AI는 이것을{' '}
                <strong className="text-gray-900" data-id="element-8059" data-mp="2t0a7dqispq99">거래적 의사 소통</strong>으로
                감지합니다.
              </p>
            </section>

            <section id="dry-texting" className="mb-16" data-id="element-8060" data-mp="1rn7sby8dwbhj">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8061" data-mp="1ror3jaf6nwcg">
                3️⃣ 감정 없는 "단답형"
              </h2>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-8062" data-mp="1hwd10fga6lp8">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-8063" data-mp="1cy1qe2i5w75y">
                  "응."
                  <br data-id="element-8064" data-mp="18vx27jahg2qp" />
                  "ㅇㅇ."
                  <br data-id="element-8065" data-mp="18xrob0xhq0wd" />
                  "👍"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600 mb-8" data-id="element-8066" data-mp="13w2d9la9pn8a">
                AI는 이러한 <strong className="text-gray-900" data-id="element-8067" data-mp="yx7hlir7c46r">단절 신호</strong>
                를 즉시 포착합니다.
              </p>
            </section>

            <section id="ghost-return" className="mb-16" data-id="element-8068" data-mp="u0h1wwjb7alv">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8069" data-mp="2tcjv4yhqjjcq">
                4️⃣ 잠수 & 복귀 아티스트
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-8070" data-mp="2odgo58i73324">
                3주 동안 사라집니다. 다음과 같이 돌아옵니다:
              </p>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-8071" data-mp="2ws4u81a868cu">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-8072" data-mp="30tgbnjiy3n9y">
                  "안녀엉 😁"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8073" data-mp="3alvtmgu8sbuu">
                AI는 이것을{' '}
                <strong className="text-gray-900" data-id="element-8074" data-mp="2dvlfmwgnjs8w">일관성 없는 참여</strong>로
                표시합니다.
              </p>
            </section>

            <section id="guilt-tripper" className="mb-16" data-id="element-8075" data-mp="2hxgkuc1pepry">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8076" data-mp="2mw1ludos5dhg">
                5️⃣ 미묘한 죄책감 유발자
              </h2>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-8077" data-mp="2rvnv6c1hm9kz">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-8078" data-mp="24hlol8w7xk5">
                  "그럼 나 혼자 갈게..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600 mb-8" data-id="element-8079" data-mp="76gpfw8jowhm">
                AI는 이것을{' '}
                <strong className="text-gray-900" data-id="element-8080" data-mp="3dnp69nllh8py">수동적 조작</strong>으로
                표시합니다.
              </p>
            </section>

            <section id="faux-supporter" className="mb-16" data-id="element-8081" data-mp="3nklhi12vo8y7">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8082" data-mp="3nhpmakiezydg">
                6️⃣ 가짜 지지자
              </h2>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-8083" data-mp="2uuv3rt55r92m">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-8084" data-mp="2pwjt5g71gujc">
                  "내 말은, 네가 가끔 과민 반응하는 경향이 있다는 거야."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8085" data-mp="34mishmabyc0e">
                AI는 <strong className="text-gray-900" data-id="element-8086" data-mp="2ztplerre2rl5">가면을 쓴 비판</strong>을
                감지합니다.
              </p>
            </section>

            <section id="healthy-toxic-combo" className="mb-16" data-id="element-8087" data-mp="2c2sjm7tb5anm">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8088" data-mp="2750shg0hlskh">
                7️⃣ "건강-유독" 콤보
              </h2>
              <div className="bg-gray-50 border border-gray-200 rounded-xl p-8 mb-8" data-id="element-8089" data-mp="mlonqp0cnxmt">
                <p className="mb-4 text-lg text-gray-700" data-id="element-8090" data-mp="rfstj4xvpzmb">
                  어떤 날은 따뜻함. 어떤 날은 차가움.
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600 mb-8" data-id="element-8091" data-mp="hoezhcop5s0k">
                AI는 이 패턴을{' '}
                <strong className="text-gray-900" data-id="element-8092" data-mp="15eiu4ujwqhff">불안정한 감정 리듬</strong>
                으로 표시합니다.
              </p>
            </section>

            <section className="mb-16" data-id="element-8093" data-mp="1ac13un5r10oh">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8094" data-mp="1aazpo9tfry2j">
                이것이 중요한 이유
              </h2>
              <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl p-10 mb-10 border border-red-100" data-id="element-8095" data-mp="10emwdd1szm8b">
                <p className="font-bold mb-8 text-2xl text-gray-900" data-id="element-8096" data-mp="3h2qutuqrkbm2">
                  패턴을 보면 다음을 할 수 있습니다:
                </p>
                <ul className="space-y-5" data-id="element-8097" data-mp="3l6q2dnu2g03a">
                  <li className="flex items-start gap-4 text-lg text-gray-700" data-id="element-8098" data-mp="57novn54pyke">
                    <span className="text-red-600 font-bold text-xl flex-shrink-0" data-id="element-8099" data-mp="gfgmufjcj8t">
                      ✓
                    </span>
                    <span data-id="element-8100" data-mp="3rnrx178lgsno">에너지 보호</span>
                  </li>
                  <li className="flex items-start gap-4 text-lg text-gray-700" data-id="element-8101" data-mp="3mnng5g3rxvwx">
                    <span className="text-red-600 font-bold text-xl flex-shrink-0" data-id="element-8102" data-mp="3mlkgs5gqeqfj">
                      ✓
                    </span>
                    <span data-id="element-8103" data-mp="j6ezv0op344b">경계 설정</span>
                  </li>
                  <li className="flex items-start gap-4 text-lg text-gray-700" data-id="element-8104" data-mp="j4u3r6mqfd4c">
                    <span className="text-red-600 font-bold text-xl flex-shrink-0" data-id="element-8105" data-mp="e694paj7uzhh">
                      ✓
                    </span>
                    <span data-id="element-8106" data-mp="2yy2uuqk5emkh">죄책감 느끼지 않기</span>
                  </li>
                </ul>
              </div>
            </section>

            <section id="faq" className="mb-20" data-id="element-8107" data-mp="2uvy35xd9g00h">
              <h2 className="text-4xl font-bold mb-10 tracking-tight text-gray-900" data-id="element-8108" data-mp="2uv69wt74yedd">
                자주 묻는 질문
              </h2>
              <div className="space-y-5" data-id="element-8109" data-mp="1eg0gs3ojaxjf">
                {faqSchema.mainEntity.map((faq, index) => <div key={index} className="bg-white rounded-xl p-8 border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-8110" data-mp="1jfda979wv2uz" data-mpi={index}>
                    <h3 className="font-bold text-xl mb-4 text-gray-900" data-id="element-8111" data-mp="1t56lg7655fyp">
                      {faq.name}
                    </h3>
                    <p className="text-gray-600 leading-relaxed text-lg" data-id="element-8112" data-mp="1y2yfp7u9de62">
                      {faq.acceptedAnswer.text}
                    </p>
                  </div>)}
              </div>
            </section>
          </div>

          <div className="bg-red-600 rounded-2xl p-12 md:p-16 text-center text-white shadow-xl" data-id="element-8113" data-mp="272bpk1mao4rb">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight" data-id="element-8114" data-mp="7ty5p29mdydd">
              😮‍💨 지친 기분은 그만.
              <br data-id="element-8115" data-mp="1g1apnta8n0oj" />
              명확하게 보기 시작하세요.
            </h2>
            <p className="text-red-100 mb-10 text-xl leading-relaxed max-w-2xl mx-auto" data-id="element-8116" data-mp="1g3ol438tyewm">
              추측은 그만하세요. 텍스트를 Toxic Detector에 업로드하고 즉시 독성
              점수를 받으세요.
            </p>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 mb-10 border border-white/20" data-id="element-8117" data-mp="1p3k1qnl5n241">
              <p className="font-bold text-2xl" data-id="element-8118" data-mp="1k1uor2edgedb">
                "⚠️ 감정적 소모: 높음. 일방적인 의사 소통 감지됨."
              </p>
            </div>
            <Link to="/upload" className="inline-block bg-white text-red-600 px-12 py-5 rounded-xl font-bold text-lg hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl hover:scale-105" data-id="element-8119" data-mp="1u1ljn56ugvdx">
              지금 채팅 스캔하기 →
            </Link>
          </div>

          <div className="mt-20" data-id="element-8120" data-mp="2hqxs22uckzf6">
            <RelatedBlogPosts posts={[{
            title: '왜 어떤 사람들은 우리를 지치게 합니까? 2부',
            description: '과도한 설명과 잘난 체하는 사람을 포함하여 에너지를 고갈시키는 더 미묘한 패턴.',
            slug: 'emotional-drain-part-2',
            emoji: '😭'
          }, {
            title: '수동적 공격적인 텍스트에 대한 궁극적인 가이드',
            description: '문자 메시지에서 수동적 공격적인 행동과 숨겨진 조작을 발견하세요.',
            slug: 'ultimate-guide-passive-aggressive-texts',
            emoji: '😤'
          }]} data-id="element-8121" data-mp="2hrzet4kq7acq" />
          </div>

          <div className="mt-16 text-center" data-id="element-8122" data-mp="2dlalp7yqlt6o">
            <button onClick={handleShare} className="inline-flex items-center gap-2 text-gray-700 hover:text-red-600 font-semibold transition-colors px-6 py-3 rounded-lg hover:bg-gray-50" data-id="element-8123" data-mp="2iex1va440f78">
              <Share2 size={20} data-id="element-8124" data-mp="28obtww2jpybn" />이 기사 공유하기
            </button>
          </div>
        </article>

        <footer className="bg-gray-900 text-white py-16 mt-24" data-id="element-8125" data-mp="1up2qkwzfuyp3">
          <div className="max-w-4xl mx-auto px-6" data-id="element-8126" data-mp="1yq4jkw2rieim">
            <div className="border-t border-gray-800 pt-8 text-center" data-id="element-8127" data-mp="1yrpbsf1ltldb">
              <p className="text-gray-400 text-sm" data-id="element-8128" data-mp="2f4viys8iv0bg">
                © {new Date().getFullYear()} ToxicDetector. 판권 소유.
              </p>
            </div>
          </div>
        </footer>
      </div>
    </>;
}